import { cn } from "@/lib/utils";

interface RocketCoinProps {
  className?: string;
  mirrored?: boolean;
}

export function RocketCoin({ className, mirrored = false }: RocketCoinProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={cn("", className)}
      fill="none"
      style={{
        transform: `translate(0, 0.5px) rotate(-45deg) scale(0.85)${mirrored ? ' scale(-1, 1)' : ''}`
      }}
    >
      {/* Lucide Rocket */}
      <path
        d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"
        stroke="var(--color-header-accent, #0A74FF)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"
        stroke="var(--color-header-accent, #0A74FF)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"
        stroke="var(--color-header-accent, #0A74FF)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"
        stroke="var(--color-header-accent, #0A74FF)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Metallic Blue Coin */}
      <circle
        cx="16"
        cy="7"
        r="2.5"
        fill="var(--color-header-accent, #0A74FF)"
        stroke="var(--color-header-accent, #0A74FF)"
        strokeWidth="1"
      />
      {/* Coin Detail */}
      <path
        d="M15 7H17M16 6V8"
        stroke="var(--color-header-accent, #0A74FF)"
        strokeWidth="1"
      />
    </svg>
  );
}
